<template>
  <div class="solution-section">
    <div class="solution-wrapper">
      <h3>解决方案</h3>
      <picture class="bgImg" v-if="currentIndex === 0">
        <source media="(max-width: 1600px)" srcset="../../assets/home/s14401.webp" />
        <source media="(min-width: 1601px)" srcset="../../assets/home/s1.webp" />
        <img src="../../assets/home/s1.webp" alt="应急管理" />
      </picture>

      <picture class="bgImg" v-if="currentIndex === 1">
        <source media="(max-width: 1600px)" srcset="../../assets/home/s14402.webp" />
        <source media="(min-width: 1601px)" srcset="../../assets/home/s2.webp" />
        <img src="../../assets/home/s2.webp" alt="语音压缩" />
      </picture>
      
      <div class="solution-content content_wrapper">
        <div class="left-content">
          <p class="menu-item" :class="currentIndex === 0 ? 'active' : ''" @mouseover="choseActive(0)">应急通信</p>
          <p class="menu-item" :class="currentIndex === 1 ? 'active' : ''" @mouseover="choseActive(1)">定制应用</p>
        </div>

        <div class="right-content">
          <div v-if="currentIndex === 0" class="emergency-content content-item">
            <div class="title-content">
              <h3>北斗应急通信方案</h3>
              <p class="line"></p>
            </div>
            <div class="center-content">
              <h4 class="title">解决窄宽物联网通信痛点</h4>
              <div class="charact space-between flex-wrap">
                <div class="charact-item flex-start">
                  <span class="dot"></span>
                  <span>极致压缩比</span>
                </div>
                <div class="charact-item flex-start">
                  <span class="dot"></span>
                  <span>超高压缩效率</span>
                </div>

                <div class="charact-item flex-start">
                  <span class="dot"></span>
                  <span>高保真效果</span>
                </div>
              </div>
              <router-link to="/solution/voice" class="btn-content">了解详情</router-link>
              <p class="dash-line"></p>
            </div>
            <div class="bottom-content">
              <img src="../../assets/home/yj2.png" alt="方案类型" />
            </div>
          </div>
          <div v-if="currentIndex === 1" class="custom-content content-item">
            <div class="title-content">
              <h3>定制卫星应用方案</h3>
              <p class="line"></p>
            </div>
            <div class="center-content">
              <h4 class="title">一站式OEM专属定制</h4>
              <div class="charact space-between flex-wrap">
                <div class="charact-item flex-start">
                  <span class="dot"></span>
                  <span>多年开发经验</span>
                </div>
                <div class="charact-item flex-start">
                  <span class="dot"></span>
                  <span>更新速度快</span>
                </div>

                <div class="charact-item flex-start">
                  <span class="dot"></span>
                  <span>基本成熟应用二次开发</span>
                </div>
              </div>
              <router-link to="/solution/custom" class="btn-content">了解详情</router-link>
              <p class="dash-line"></p>
            </div>
            <div class="bottom-content">
              <img src="../../assets/home/dz2.png" alt="定制类型" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
    };
  },
  methods: {
    choseActive(index) {
      this.currentIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.solution-section {
  width: 100%;
  height: 640px;
  h3 {
    text-align: center;
  }
  .solution-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    h3 {
      text-align: center;
      padding-top: 60px;
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
    }
    .bgImg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
    .solution-content {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 50px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      .left-content {
        height: 450px;
        border-right: 1px solid rgba(37, 46, 67, 0.1);
        .menu-item {
          height: 45px;
          line-height: 45px;
          color: #000;
          font-size: 18px;
          padding: 0px 30px;
          margin-top: 20px;
          position: relative;
        }
      }
      .right-content {
        margin-left: 55px;
        .content-item {
          .title-content {
            h3 {
              padding: 0;
              font-size: 32px;
              font-weight: 400;
              color: #0d0e24;
              text-align: left;
            }
            .line {
              margin-top: 15px;
              width: 42px;
              height: 2px;
              background: #0d0e24;
            }
          }
          .center-content {
            margin-top: 50px;

            .title {
              font-size: 22px;
              font-weight: 300;
              color: #4173fb;
            }
            .charact {
              width: 320px;
              .charact-item {
                margin-top: 24px;
                span {
                  font-size: 18px;
                  font-weight: 300;
                  color: #202020;
                }
                .dot {
                  width: 7px;
                  height: 7px;
                  background: #68696c;
                  border-radius: 50%;
                  margin-right: 5px;
                }
              }
            }

            .btn-content {
              display: inline-block;
              margin-top: 48px;
              margin-bottom: 55px;
              width: 110px;
              height: 34px;
              border: 1px solid #4173fb;
              border-radius: 17px;
              line-height: 34px;
              text-align: center;
              text-decoration: none;
              font-size: 14px;
              color: #4173fb;
              cursor: pointer;
            }

            .dash-line {
              width: 800px;
              height: 1px;
              border-bottom: 1px dashed #68696c;
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }
}
.active {
  color: #3d6eff;
  background: linear-gradient(90deg, hsla(0, 0%, 93.3%, 0), #c5d1ed);
  &:after {
    content: '';
    display: inline-block;
    background: #3d6eff;
    position: absolute;
    right: -2px;
    top: 0;
    height: 100%;
    width: 3px;
  }
}
</style>